<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0 mb-1 elevation-1" style="max-height: 2.55rem">
        <v-col class="p-0">
          <v-row class="m-0" style="height: 2.55rem">
            <span v-if="!isNew" style="margin-top: auto;
                     margin-bottom: auto; margin-left: 12px;" class="text-h6">{{ azra.bis_id }}</span>
            <v-text-field
                placeholder="Rastername (bitte eingeben)"
                hide-details
                single-line
                :rules="[rules.required, rules.counter]"
                counter
                maxlength="50"
                v-model="azra.name"
                style="padding-top: 0; margin-top: auto; margin-bottom: auto; margin-left: 12px; max-width: 250px !important; font-weight: 500"
            ></v-text-field>
            <!--b-form-radio-group
                style="margin-left: auto;
                        margin-top: auto;
                         margin-bottom: auto;"
                v-model="selectedDate"
                :options="dateOptions"
                button-variant="outline-primary"
                buttons
            ></b-form-radio-group-->
            <v-switch
                v-model="hasOscillation"
                :disabled="mustOscillate"
                class="t-btn-left"
                style="margin-right: 18px"
                hide-details
                dense
                :label="`Wochen pro Phase`"
            ></v-switch>
            <v-btn
                v-if="!isNew"
                block
                color="error"
                @click="showDelete = true"
                class="t-btn"
            >
              <v-icon left>
                mdi-delete
              </v-icon>
              Löschen
            </v-btn>
            <v-btn
                :class="{'white--text': true, 't-btn': true, 't-btn-left': false}"
                color="primary"
                block
                @click="$refs.assignUserDialog.show()"
            >
              <v-badge
                  color="success"
                  inline
                  :content="assignedUsers.length"
                  :value="assignedUsers.length"
              >
                <v-icon left>
                  mdi-account-edit
                </v-icon>
              </v-badge>
              Zuweisen
            </v-btn>
            <v-btn
                block
                color="success"
                @click="save()"
                class="t-btn"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              {{ isNew ? 'Erstellen' : isImport ? 'Importieren' : 'Speichern' }}
            </v-btn>
            <v-btn
                outlined
                fab
                class="t-btn"
                color="primary"
                style="width: 32px!important; min-width: 32px!important; max-width: 32px!important;"
                @click="$router.go(-1)"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col class="p-0 custom-col-5">
          <v-tabs
              v-model="currentTab"
              ref="tabs">
            <v-tab
                v-for="item in tab_items"
                :key="item.id"
                @click="onTabClick(item.id)"
            >
              <v-icon left v-if="item.id === 'new'">
                mdi-plus
              </v-icon>
              {{ item.name }}
              <v-icon right v-if="item.id !== 'new'" style="color: red"
                      @click="currentDeleteAzra = item.id; currentDeleteSubAzra = null; showDeleteAzra = true">
                mdi-delete
              </v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs
              v-model="currentSubTab"
              ref="sub_tabs" v-if="subAzras.length && hasOscillation && currentTabName !== 'new'">
            <v-tab
                v-for="item in sub_tab_items"
                :key="item.id"
                @click="onSubTabClick(item.id)"
            >
              <v-icon left v-if="item.id === 'new-sub'">
                mdi-plus
              </v-icon>
              {{ item.name }}
              <v-icon right v-if="item.id !== 'new-sub'" style="color: red"
                      @click="currentDeleteAzra = null; currentDeleteSubAzra = item.id; showDeleteAzra = true">
                mdi-delete
              </v-icon>
            </v-tab>
          </v-tabs>
        </v-col>
        <v-col class="custom-col-1" style="padding: 4px">
          <v-text-field
              class=""
              label="Wochenstunden"
              dense
              outlined
              readonly
              hide-details
              v-model="sumValenceWeekHours"
          ></v-text-field>
        </v-col>
        <v-col class="custom-col-1" style="padding: 4px">
          <v-text-field
              class=""
              label="Soll-Wochenstunden"
              dense
              outlined
              readonly
              hide-details
              v-model="sumWeekHours"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="m-0" style="flex: 1 0 auto;" v-if="currentAzra">
        <v-col class="p-0 p-3" v-for="day in days"
               :key="day.day"
               style="border-right: 1px solid grey; border-top: 1px solid grey">
          <h6 style="text-align: center">{{ day.day_name }}</h6>
          <v-text-field
              class="mt-6"
              label="Sollstunden"
              :rules="hour_rules"
              placeholder="00:00"
              hint="Format: HH:MM"
              filled
              readonly
              v-model="currentAzra['hours_' + day.day]"
              disabled
          ></v-text-field>
          <v-text-field
              class="mt-6"
              label="Wertigkeit"
              :rules="float_rules"
              placeholder="0"
              outlined
              hint="Format: Dezimalzahl (z.B. 7,5)"
              v-model="currentAzra['valence_hours_' + day.day]"
          ></v-text-field>
          <v-text-field
              class="mt-6"
              label="Arbeitszeit"
              :rules="hours_rules"
              outlined
              v-model="currentAzra['time_' + day.day]"
              :key="'time_' + day.day"
              hint="Format: HH:MM-HH:MM"
              v-windows-time
              @input="dayInput(day.day)"
          ></v-text-field>
          <v-text-field
              class="mt-6"
              label="Pause 1"
              :rules="hours_rules"
              placeholder="00:00-00:00"
              outlined
              v-model="currentAzra['break_1_' + day.day]"
              hint="Format: HH:MM-HH:MM"
              v-windows-time
              @input="dayInput(day.day)"
          ></v-text-field>
          <v-text-field
              class="mt-6"
              label="Pause 2"
              :rules="hours_rules"
              placeholder="00:00-00:00"
              outlined
              v-model="currentAzra['break_2_' + day.day]"
              hint="Format: HH:MM-HH:MM"
              v-windows-time
              @input="dayInput(day.day)"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-alert
          style="position: absolute;right: 12px;bottom: 0px;"
          v-model="alert"
          dismissible
          type="error"
      >
        {{ errorMessage }}
      </v-alert>
    </div>
    <new-phase-dialog ref="newPhaseDialog" @submit="addNewSubAzra" :phases="subAzras"
                      @cancel="onCancelNewAzra"></new-phase-dialog>
    <begin-dialog ref="beginDialog" @submit="doSave"></begin-dialog>
    <assign-user-dialog ref="assignUserDialog" :bh-structure="bhStructure" :pre-selected="assignedUsers"
                        @submit="changeAssignedUsers"></assign-user-dialog>
    <v-dialog
        v-model="showDelete"
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Arbeitszeitraster löschen ?
        </v-card-title>

        <v-card-text>
          Wollen Sie das Arbeitszeitraster wirklich löschen ?<br>Die Arbeitszeiten der zugewiesenen Mitarbeiter werden
          auch gelöscht und müssen neu zugewiesen werden.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text
              @click="showDelete = false"
          >
            Abbbrechen
          </v-btn>

          <v-btn
              color="red darken-1"
              text
              @click="onDelete"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showDeleteAzra"
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          {{currentDeleteAzra ? 'Phase löschen ?' : 'Woche löschen ?' }}
        </v-card-title>

        <v-card-text>
          {{currentDeleteAzra ? 'Wollen Sie diese Phase wirklich löschen ?' : 'Wollen Sie diese Woche wirklich löschen ?' }}<br>
          Die Phasen eines Arbeitszeitrasters müssen das ganze Jahr
          abdecken um gespeichert werden zu können.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              text
              @click="showDeleteAzra = false"
          >
            Abbbrechen
          </v-btn>

          <v-btn
              color="red darken-1"
              text
              @click="removeSubAzra(currentDeleteAzra, currentDeleteSubAzra)"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showImportDialog"
        max-width="400"
    >
      <v-card>
        <v-card-title class="text-h5">
          Arbeitszeitraster importieren
        </v-card-title>

        <v-card-text>
          Dieses Arbeitszeitraster muss importiert werden um mit der automatischen Anlage von Arbeitszeiten zu
          funktionieren.<br>Im nächsten Schritt können Sie die Phasen des Arbeitszeitrasters importieren.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
              color="blue darken-1"
              text
              @click="showImportDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import {v4} from "uuid";
import NewPhaseDialog from "@/views/basis_data/dialogs/new_phase_dialog.vue";
import AssignUserDialog from "@/views/basis_data/dialogs/assign_user_dialog.vue";
import BeginDialog from "@/views/basis_data/dialogs/azra_begin_dialog.vue";
import {DateTime as LuxonDateTime} from "luxon";
//import { IMaskDirective } from 'vue-imask';
import IMask from 'imask'; // <-- Add this line
export default {
  name: "azra_detail",
  components: {
    NewPhaseDialog, AssignUserDialog, BeginDialog
  },
  directives: {
    windowsTime: {
      inserted(el) {
        const input = el.querySelector('input');
        if (!input) return;

        if (!input.value) {
          input.value = '00:00-00:00';
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        // 1. Highlight specific block on click
        input.addEventListener('click', () => {
          const pos = input.selectionStart;
          if (pos <= 2) input.setSelectionRange(0, 2);
          else if (pos <= 5) input.setSelectionRange(3, 5);
          else if (pos <= 8) input.setSelectionRange(6, 8);
          else input.setSelectionRange(9, 11);
        });

        // 2. Intercept keystrokes (Same as before)
        input.addEventListener('keydown', (e) => {
          const key = e.key;

          // Allow normal browser shortcuts to pass through to our copy/paste events
          if (key === 'Tab' || e.ctrlKey || e.metaKey) return;

          e.preventDefault();

          let pos = input.selectionStart;
          let val = input.value;

          // NAVIGATION
          if (['ArrowRight', ':', '-'].includes(key)) {
            if (pos <= 2) input.setSelectionRange(3, 5);
            else if (pos <= 5) input.setSelectionRange(6, 8);
            else if (pos <= 8) input.setSelectionRange(9, 11);
            return;
          }
          if (key === 'ArrowLeft') {
            if (pos >= 9) input.setSelectionRange(6, 8);
            else if (pos >= 6) input.setSelectionRange(3, 5);
            else if (pos >= 3) input.setSelectionRange(0, 2);
            return;
          }

          // DELETING
          if (['Backspace', 'Delete'].includes(key)) {
            if (input.selectionStart !== input.selectionEnd) {
              let s = input.selectionStart;
              let end = input.selectionEnd;
              let newVal = val;
              for (let i = s; i < end; i++) {
                if (newVal[i] !== ':' && newVal[i] !== '-') {
                  newVal = newVal.substring(0, i) + '0' + newVal.substring(i + 1);
                }
              }
              input.value = newVal;
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.setSelectionRange(s, s);
            } else if (key === 'Backspace' && pos > 0) {
              pos--;
              if (val[pos] === ':' || val[pos] === '-') pos--;
              input.value = val.substring(0, pos) + '0' + val.substring(pos + 1);
              input.dispatchEvent(new Event('input', { bubbles: true }));
              input.setSelectionRange(pos, pos);
            }
            return;
          }

          // TYPING NUMBERS
          if (/^\d$/.test(key)) {
            if (pos === 2 || pos === 5 || pos === 8) pos++;
            if (pos >= 11) return;

            input.value = val.substring(0, pos) + key + val.substring(pos + 1);
            input.dispatchEvent(new Event('input', { bubbles: true }));

            pos++;

            if (pos === 2 || pos === 5 || pos === 8) {
              pos++;
              input.setSelectionRange(pos, pos + 2);
            } else {
              input.setSelectionRange(pos, pos);
            }
          }
        });

        // 3. OVERRIDE NATIVE COPY
        input.addEventListener('copy', (e) => {
          e.preventDefault();
          // Force the clipboard to copy the entire input string, ignoring selection
          e.clipboardData.setData('text/plain', input.value);
        });

        // 4. OVERRIDE NATIVE PASTE
        input.addEventListener('paste', (e) => {
          e.preventDefault();
          const pastedData = (e.clipboardData || window.clipboardData).getData('text');
          const cleanPaste = pastedData.trim();

          // Only overwrite if they pasted a valid time format (XX:XX-XX:XX)
          if (/^\d{2}:\d{2}-\d{2}:\d{2}$/.test(cleanPaste)) {
            input.value = cleanPaste;
            // Tell Vue to update the v-model
            input.dispatchEvent(new Event('input', { bubbles: true }));
          }
        });

      }
    }
  },
  data() {
    return {
      maskOptions: {
        mask: 'HH:MM-hh:mm',
        lazy: false,
        overwrite: true,
        // Removed the placeholderChar to stop it from eating real zeroes
        blocks: {
          HH: { mask: IMask.MaskedRange, from: 0, to: 23, maxLength: 2, autofix: 'pad' },
          MM: { mask: IMask.MaskedRange, from: 0, to: 59, maxLength: 2, autofix: 'pad' },
          hh: { mask: IMask.MaskedRange, from: 0, to: 23, maxLength: 2, autofix: 'pad' },
          mm: { mask: IMask.MaskedRange, from: 0, to: 59, maxLength: 2, autofix: 'pad' }
        }
      },
      isNew: false,
      isImport: false,
      templateId: undefined,
      azra: {
        id: '',
        bis_id: '',
        name: '',
        access: '', // same as bis_id
      },
      bhStructure: [],
      assignedUsers: [],
      subAzras: [],
      currentAzraName: '',
      currentAzra: null,
      loader: undefined,
      currentTab: null,
      currentSubTab: null,
      rules: {
        required: value => !!value || 'Muss ausgefüllt werden',
        counter: value => value.length <= 50 || 'Maximal 50 Zeichen erlaubt',
      },
      alert: false,
      errorMessage: null,
      days: [
        {day: 'mon', day_name: "Montag"},
        {day: 'tue', day_name: "Dienstag"},
        {day: 'wed', day_name: "Mittwoch"},
        {day: 'thu', day_name: "Donnerstag"},
        {day: 'fri', day_name: "Freitag"},
        {day: 'sat', day_name: "Samstag"},
        {day: 'sun', day_name: "Sonntag"},
      ],
      // /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/
      hour_rules: [
        value => !!value || '*erforderlich',
        value => {
          const pattern = /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/
          return pattern.test(value) || 'Die Eingabe muss im Format HH:MM sein.'
        },
      ],
      float_rules: [
        value => !!value || '*erforderlich',
        value => {
          const pattern = /^\d+(\,\d{1,2})?$/
          return pattern.test(value) || 'Die Eingabe muss eine Zahl mit maximal zwei Nachkommastellen sein.'
        },
      ],
      hours_rules: [
        value => !!value || '*erforderlich',
        value => {
          const pattern = /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)-(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/
          return pattern.test(value) || 'Die Eingabe muss im Format HH:MM-HH:MM sein.'
        },
      ],
      showDelete: false,
      showDeleteAzra: false,
      currentDeleteAzra: null,
      currentDeleteSubAzra: null,
      showImportDialog: false,
      sumWeekHours: '00:00',
      sumValenceWeekHours: '00:00',
      hasOscillation: false
    }
  },
  mounted() {
  },
  watch: {
    rasterName(newValue) {
      this.errorMessage = null;
      this.alert = false;
    },
    currentTab(newValue, oldValue) {
    },
    currentSubTab(newValue, oldValue) {
    },
    currentAzra: {
      handler: function (newValue) {
        let pattern = /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/;
        if (!newValue) {
          this.sumWeekHours = "00:00";
          this.sumValenceWeekHours = "00:00";
        } else {
          let sum = 0;
          for (let i = 0; i < this.days.length; i++) {
            let hours = this.currentAzra['hours_' + this.days[i].day];
            if (pattern.test(hours)) {
              let splits = hours.split(':');
              sum += parseInt(splits[0]) * 60 + parseInt(splits[1]);
            }
          }
          let hours = Math.floor(sum / 60);
          let minutes = sum % 60;
          this.sumWeekHours = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;

          pattern = /^\d+(\,\d{1,2})?$/;
          sum = 0;
          for (let i = 0; i < this.days.length; i++) {
            let hours = this.currentAzra['valence_hours_' + this.days[i].day];
            if (pattern.test(hours)) {
              hours = hours.replace(',', '.');
              sum += parseFloat(hours);
            }
          }
          this.sumValenceWeekHours = sum.toFixed(2).replace('.', ',');
        }
      },
      deep: true
    }
  },
  computed: {
    mustOscillate() {
      let names = new Set();
      for (let i = 0; i < this.subAzras.length; i++) {
        let name = this.formatName(this.subAzras[i]);
        if (names.has(name)) {
          return true;
        }
        names.add(name);
      }
      return false;
    },
    tab_items() {
      let res = new Map();
      for (let i = 0; i < this.subAzras.length; i++) {
        let name = this.formatName(this.subAzras[i]);
        res.set(name, {name: name, id: name});
      }
      res.set('new', {name: this.isImport ? 'Phase importieren' : 'neue Phase', icon: 'mdi-plus', id: 'new'});
      return Array.from(res.values());
    },
    sub_tab_items() {
      let res = [];
      for (let i = 0; i < this.subAzras.length; i++) {
        let name = this.formatName(this.subAzras[i]);
        if (name === this.currentTabName) {
          res.push({name: 'Woche #' + (res.length + 1), id: this.subAzras[i].id});
        }
      }
      res.push({name: 'neue Woche', icon: 'mdi-plus', id: 'new-sub'});
      return res;
    },
    currentTabName() {
      if (this.currentTab === null || this.currentTab === undefined) {
        return null;
      }
      return this.$refs.tabs.$children[0].$children[this.currentTab + 1].$vnode.key;
    },
  },
  created() {
    this.isNew = this.$route.params.id === '0';
    this.templateId = this.$route.query.template;
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/basis_data/azra/' + this.$route.params.id + (this.templateId ? "?template=" + this.templateId : "")
    ).then(this.responseOkGet, this.responseError)
  },
  methods: {
    onMaskAccept(value, day) {
      value = value.replaceAll(/\s/g,'');
      console.log(value)
      // Use $set to ensure Vue 2's reactivity system catches the dynamic object update
      this.$set(this.currentAzra, 'time_' + day, value);
      // Trigger your original logic
      this.dayInput(day);
    },
    dayInput(day) {
      const pattern = /^(?:([01]\d|2[0-3]):[0-5]\d|24:00)-(?:([01]\d|2[0-3]):[0-5]\d|24:00)$/
      let sum = 0;
      let time = this.currentAzra['time_' + day];
      if (pattern.test(time)) {
        let splits = time.split('-');
        let start = splits[0].split(':');
        let end = splits[1].split(':');
        sum += (parseInt(end[0]) * 60 + parseInt(end[1])) - (parseInt(start[0]) * 60 + parseInt(start[1]));
        // try to subtract the breaks
        let break1 = this.currentAzra['break_1_' + day];
        if (pattern.test(break1)) {
          splits = break1.split('-');
          start = splits[0].split(':');
          end = splits[1].split(':');
          sum -= (parseInt(end[0]) * 60 + parseInt(end[1])) - (parseInt(start[0]) * 60 + parseInt(start[1]));
        }
        let break2 = this.currentAzra['break_2_' + day];
        if (pattern.test(break2)) {
          splits = break2.split('-');
          start = splits[0].split(':');
          end = splits[1].split(':');
          sum -= (parseInt(end[0]) * 60 + parseInt(end[1])) - (parseInt(start[0]) * 60 + parseInt(start[1]));
        }
      }
      if (sum < 0) {
        sum = 0;
      }
      let hours = Math.floor(sum / 60);
      let minutes = sum % 60;
      this.currentAzra['hours_' + day] = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
      this.currentAzra['valence_hours_' + day] = (sum / 60.0).toFixed(2).replace('.', ',');
    },
    save() {
      if (!this.inConsistent()) {
        return;
      }
      this.$refs.beginDialog.show();
    },
    doSave(beginTime) {
      this.showLoader();
      for (let i = 0; i < this.subAzras.length; i++) {
        this.subAzras[i].week_order = i;
      }
      let data = {
        main_azra: this.azra,
        assigned_users: this.assignedUsers,
        sub_azras: this.subAzras,
        assign_start: beginTime
      }
      this.$http.post(
          Server_URL_ZK + '/zk/basis_data/azra',
          data
      ).then(this.responseOkSave, this.responseError)
    },
    onDelete() {
      this.showDelete = false;
      this.showLoader();
      this.$http.delete(
          Server_URL_ZK + '/zk/basis_data/azra/' + this.azra.id
      ).then(this.responseOkDelete, this.responseError)
    },
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    responseOkSave(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.azra = response.body.main_azra;
        this.subAzras = response.body.sub_azras;
        this.isNew = false;
        this.isImport = false;
        this.$nextTick(() => {
          this.setCurrentTab(this.formatName(this.subAzras[0]), this.subAzras[0].id);
        });
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        if (!this.isNew) {
          this.azra = response.body.main_azra;
          this.assignedUsers = response.body.assigned_users;
          this.subAzras = response.body.sub_azras;
          let names = new Set();
          for (let i = 0; i < this.subAzras.length; i++) {
            let name = this.formatName(this.subAzras[i]);
            if (names.has(name)) {
              this.hasOscillation = true;
              break;
            }
            names.add(name);
          }
          if (this.subAzras.length) {
            this.$nextTick(() => {
              this.setCurrentTab(this.formatName(this.subAzras[0]), this.subAzras[0].id);
            })
          } else if (this.azra.id !== this.azra.dependent_id) {
            this.isImport = true;
            this.showImportDialog = true;
          }
        } else if (this.templateId) {
          this.azra = response.body.main_azra;
          this.azra.name = this.azra.name + " (Kopie)";
          this.azra.id = '';
          this.azra.dependent_id = '';
          this.azra.bis_id = '';
          this.azra.access = '';
          this.assignedUsers = [];
          this.subAzras = response.body.sub_azras;
          for (let i = 0; i < this.subAzras.length; i++) {
            this.subAzras[i].id = v4();
            this.subAzras[i].bis_id = "";
            this.subAzras[i].dependent_id = "";
            this.subAzras[i].access = "";
          }
          let names = new Set();
          for (let i = 0; i < this.subAzras.length; i++) {
            let name = this.formatName(this.subAzras[i]);
            if (names.has(name)) {
              this.hasOscillation = true;
              break;
            }
            names.add(name);
          }
          this.$nextTick(() => {
            this.setCurrentTab(this.formatName(this.subAzras[0]), this.subAzras[0].id);
          })
        }
        this.bhStructure = response.body.bh_structure;
        this.computeMitas(this.bhStructure);
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkDelete(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.$router.go(-1);
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkImportPhase(response) {
      this.hideLoader();
      if (response.status === 200) {
        let id = v4();
        let newAzra = response.body;
        newAzra.id = id;
        newAzra.dependent_id = this.azra.id;
        this.subAzras.push(this.formatName(newAzra), newAzra);
        this.$nextTick(() => {
          this.setCurrentTab(id);
          this.onTabClick(this.formatName(newAzra));
        })
      } else {
        window.location = Redirect_500;
      }
    },
    computeMitas(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].node_type === "user") {
          let cur = {...data[i]}
          let parsed = JSON.parse(sessionStorage.getItem(cur.id));
          if (parsed) {
            cur.text = parsed.full_name;
          }
          data[i] = cur;
        } else {
          this.computeMitas(data[i].children)
        }
      }
      data.sort((a, b) => (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : ((b.text.toLowerCase() > a.text.toLowerCase()) ? -1 : 0));
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    onTabClick(e) {
      if (e !== 'new') {
        for (let i = 0; i < this.subAzras.length; i++) {
          let name = this.formatName(this.subAzras[i])
          if (name === e) {
            let id = this.subAzras[i].id;
            this.setCurrentTab(name, id);
            break;
          }
        }
        for (let i = 0; i < this.days.length; i++) {
          this.dayInput(this.days[i].day);
        }
        return;
      }
      this.$refs.newPhaseDialog.show();
    },
    onSubTabClick(e) {
      if (e !== 'new-sub') {
        for (let i = 0; i < this.subAzras.length; i++) {
          if (this.subAzras[i].id === e) {
            this.currentAzra = this.subAzras[i];
            this.currentAzraName = this.formatName(this.currentAzra);
            break;
          }
        }
        for (let i = 0; i < this.days.length; i++) {
          this.dayInput(this.days[i].day);
        }
        return;
      }
      if (this.currentAzra) {
        this.addNewSubAzra(this.currentAzra.active_from, this.currentAzra.active_to)
      }
    },
    addNewSubAzra(from, till) {
      this.errorMessage = null;
      this.alert = false;
      if (this.isImport) {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/basis_data/azra/' + this.azra.bis_id + "/import?phase_start=" + from + "&phase_end=" + till
        ).then(this.responseOkImportPhase, this.responseError);
        return;
      }
      let id = v4();
      let newAzra = {
        id: id,
        active_from: from,
        active_to: till,
        hours_sun: '00:00',
        hours_mon: '00:00',
        hours_tue: '00:00',
        hours_wed: '00:00',
        hours_thu: '00:00',
        hours_fri: '00:00',
        hours_sat: '00:00',
        time_sun: '00:00-00:00',
        time_mon: '00:00-00:00',
        time_tue: '00:00-00:00',
        time_wed: '00:00-00:00',
        time_thu: '00:00-00:00',
        time_fri: '00:00-00:00',
        time_sat: '00:00-00:00',
        dependent_id: this.azra.id,
        break_1_sun: "00:00-00:00",
        break_1_mon: "00:00-00:00",
        break_1_tue: "00:00-00:00",
        break_1_wed: "00:00-00:00",
        break_1_thu: "00:00-00:00",
        break_1_fri: "00:00-00:00",
        break_1_sat: "00:00-00:00",
        break_2_sun: "00:00-00:00",
        break_2_mon: "00:00-00:00",
        break_2_tue: "00:00-00:00",
        break_2_wed: "00:00-00:00",
        break_2_thu: "00:00-00:00",
        break_2_fri: "00:00-00:00",
        break_2_sat: "00:00-00:00",
        valence_hours_sun: '0',
        valence_hours_mon: '0',
        valence_hours_tue: '0',
        valence_hours_wed: '0',
        valence_hours_thu: '0',
        valence_hours_fri: '0',
        valence_hours_sat: '0',
      }
      if (this.currentAzra) {
        newAzra = {...this.currentAzra};
        newAzra.id = id;
        newAzra.active_from = from;
        newAzra.active_to = till;
      }
      this.subAzras.push(newAzra);
      this.$nextTick(() => {
        this.setCurrentTab(this.formatName(newAzra), id);
        //this.onTabClick(id);
      })

    },
    changeAssignedUsers(users) {
      this.assignedUsers = users;
    },
    setCurrentTab(name, tabId) {
      for (let i = 0; i < this.$refs.tabs.$children[0].$children.length; i++) {
        if (this.$refs.tabs.$children[0].$children[i].$vnode.key === name) {
          this.currentTab = i - 1;
          break;
        }
      }
      //this.currentTab = name;
      this.$nextTick(() => {
        this.setCurrentSubTab(tabId);
      });
    },
    setCurrentSubTab(tabId) {
      if (this.hasOscillation) {
        for (let i = 0; i < this.$refs.sub_tabs.$children[0].$children.length; i++) {
          if (this.$refs.sub_tabs.$children[0].$children[i].$vnode.key === tabId) {
            this.currentSubTab = i - 1;
            break;
          }
        }
      }
      //this.currentSubTab = tabId;
      for (let i = 0; i < this.subAzras.length; i++) {
        if (this.subAzras[i].id === tabId) {
          this.currentAzra = this.subAzras[i];
          this.currentAzraName = this.formatName(this.currentAzra);
          break;
        }
      }
      for (let i = 0; i < this.days.length; i++) {
        this.dayInput(this.days[i].day);
      }
    },
    onCancelNewAzra() {
      if (this.currentAzra) {
        this.setCurrentTab(this.currentAzraName, this.currentAzra.id);
      }
    },
    removeSubAzra(phase, id) {
      let tempPhase = null;
      for (let i = this.subAzras.length -1; i >= 0; i--) {
        if (this.subAzras[i].id === id || this.formatName(this.subAzras[i]) === phase) {
          tempPhase = this.formatName(this.subAzras[i]);
          this.subAzras.splice(i, 1);
        }
      }
      console.log(tempPhase)
      // check if we still have items of the current phase
      let phaseId = null;
      for (let i = 0; i < this.subAzras.length; i++) {
        if (this.formatName(this.subAzras[i]) === tempPhase) {
          phaseId = this.subAzras[i].id;
          break;
        }
      }
      if (phaseId != null) {
        console.log('phase still there')
        this.setCurrentTab(tempPhase, phaseId);
        this.showDeleteAzra = false;
        return;
      }
      this.currentTab = null;
      this.currentAzraName = null;
      this.currentAzra = null;
      this.showDeleteAzra = false;
    },
    formatName({active_from, active_to}) {
      return this.formateActive(active_from) + " - " + this.formateActive(active_to)
    },
    formateActive(active) {
      let splits = active.split('-');
      return splits[1] + '.' + splits[0];
    },
    inConsistent() {
      this.alert = false;
      let error = null;
      this.azra.name = this.azra.name.trim();
      if (this.azra.name === '') {
        this.errorMessage = "Der Rastername muss gesetzt sein.";
        this.alert = true;
        return false;
      }
      error = this.checkYearCoverage();
      if (error) {
        this.errorMessage = error;
        this.alert = true;
        return false;
      }
      return true;
    },
    checkYearCoverage() {
      // check if the phases cover the whole year
      // for computational reasons where use the year 2142 as it is a leap year in the future
      // so the phases have to cover 366 days
      let names = new Set();
      let numDays = 0;
      for (let i = 0; i < this.subAzras.length; i++) {
        let name = this.formatName(this.subAzras[i]);
        if (!names.has(name)) {
          numDays += this.getNumberDaysInPhase(this.subAzras[i].active_from, this.subAzras[i].active_to);
        }
        names.add(name);
      }
      if (numDays !== 366) {
        return "Die Phasen müssen das ganze Jahr abdecken";
      }
      return null;
    },
    getNumberDaysInPhase(start, end) {
      if (start > end) {
        // this phase wraps around the year
        return this.getNumberDaysInPhase(start, '12-31') + this.getNumberDaysInPhase('01-01', end);
      }
      let splits = start.split('-');
      let startMonth = parseInt(splits[0]);
      let startDay = parseInt(splits[1]);
      splits = end.split('-');
      let endMonth = parseInt(splits[0]);
      let endDay = parseInt(splits[1]);
      let days = 0;
      for (let i = startMonth; i <= endMonth; i++) {
        if (i === startMonth && i === endMonth) {
          return endDay - startDay + 1;
        }
        if (i === startMonth) {
          days += this.getNumberDaysInMonth(i) - startDay + 1;
        } else if (i === endMonth) {
          days += endDay;
        } else {
          days += this.getNumberDaysInMonth(i);
        }
      }
      return days;
    },
    getNumberDaysInMonth(month) {
      if (month === 2) {
        return 29;
      }
      if (month === 4 || month === 6 || month === 9 || month === 11) {
        return 30;
      }
      return 31;
    }
  }

}
</script>

<style scoped>

::v-deep .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  cursor: pointer;
}

.theme--light.v-label {
  color: black;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

::v-deep .theme--light.v-icon.v-icon.v-icon--disabled {
  color: rgb(84, 84, 84) !important;
}

.hidden {
  visibility: hidden;
}

.hide-year ::v-deep .vdatetime-popup__year {
  display: none;
}

.t-btn {
  height: 32px !important;
  width: 180px !important;
  max-width: 180px !important;
  min-width: 180px !important;
  margin: auto 12px auto 0px;
}

.t-btn-left {
  margin: auto 12px auto auto !important;
}

::v-deep .t-btn-left .v-label {
  margin-bottom: 0px !important;
}

.custom-col-6 {
  flex: 0 0 85.715%;
  max-width: 85.715%;
}

.custom-col-1 {
  flex: 0 0 14.285%;
  max-width: 14.285%;
}

</style>

